// Location fixtures — first-class properties that group the demo zones. Lets the
// Locations tab on the Zones screen render a populated list and the Analytics
// "By location" card show real, named groupings. Sourced from the active client.

import { DEMO_CLIENT, DEMO_CLIENT_ID } from '../constants'
import { isoDaysFromNow } from '../time'
import type { FacilityResponse, FacilitiesListResponse } from '@parkify/api-types'
import type { DemoFacility } from '../clients/types'

export const DEMO_FACILITIES = DEMO_CLIENT.facilities

// GET /api/facilities → full location records.
export function demoFacilitiesList(): FacilitiesListResponse<DemoFacility> {
  return DEMO_FACILITIES.map(f => ({
    ...f,
    clientId: DEMO_CLIENT_ID,
    createdAt: isoDaysFromNow(-180),
    updatedAt: isoDaysFromNow(-5),
  }))
}

// GET /api/facilities?id=<id> → single location.
export function demoFacilityById(id: string): FacilityResponse<DemoFacility> | null {
  return demoFacilitiesList().find(f => f.id === id) ?? null
}
